/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_After_1Inputs */

const en_landing_after_1 = /** @type {(inputs: Landing_After_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume tailored to each job description`)
};

const de_landing_after_1 = /** @type {(inputs: Landing_After_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf auf jede Stellenbeschreibung zugeschnitten`)
};

const fr_landing_after_1 = /** @type {(inputs: Landing_After_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV adapté à chaque description de poste`)
};

const es_landing_after_1 = /** @type {(inputs: Landing_After_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículum adaptado a cada descripción de puesto`)
};

const it_landing_after_1 = /** @type {(inputs: Landing_After_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum su misura per ogni offerta di lavoro`)
};

const nl_landing_after_1 = /** @type {(inputs: Landing_After_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV afgestemd op elke vacaturetekst`)
};

const pl_landing_after_1 = /** @type {(inputs: Landing_After_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV dopasowane do każdego opisu stanowiska`)
};

const fi_landing_after_1 = /** @type {(inputs: Landing_After_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelo räätälöity jokaiseen työpaikkakuvaukseen`)
};

const da_landing_after_1 = /** @type {(inputs: Landing_After_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV tilpasset hver jobbeskrivelse`)
};

const sv_landing_after_1 = /** @type {(inputs: Landing_After_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV anpassat till varje jobbbeskrivning`)
};

/**
* | output |
* | --- |
* | "Resume tailored to each job description" |
*
* @param {Landing_After_1Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_after_1 = /** @type {((inputs?: Landing_After_1Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_After_1Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_after_1(inputs)
	if (locale === "fr") return fr_landing_after_1(inputs)
	if (locale === "es") return es_landing_after_1(inputs)
	if (locale === "it") return it_landing_after_1(inputs)
	if (locale === "nl") return nl_landing_after_1(inputs)
	if (locale === "pl") return pl_landing_after_1(inputs)
	if (locale === "fi") return fi_landing_after_1(inputs)
	if (locale === "da") return da_landing_after_1(inputs)
	if (locale === "sv") return sv_landing_after_1(inputs)
	return en_landing_after_1(inputs)
});